module.exports = __webpack_public_path__ + "img/logo.60195475.png";